<p-multiSelect
  *ngIf="!isTVmode"
  class="select-box-container"
  [id]="id"
  [filter]="false"
  [showToggleAll]="false"
  [options]="options"
  [(ngModel)]="selectedValues"
  [maxSelectedLabels]="1"
  optionLabel="name"
  optionValue="value"
  [disabled]="disabled"
  placeholder=""
  (onChange)="onChangeValue($event.value)"
  (onPanelShow)="removeHiddenInputs()"
>
</p-multiSelect>

<select
  *ngIf="isTVmode"
  multiple
  class="select-box-container"
  [attr.dpad]="dpad"
  [style.--scale-dpad]="scaledpad"
  [attr.x-dpad]="xdpad"
  [attr.y-dpad]="ydpad"
  [attr.tab-dpad]="tabdpad"
  [attr.x-tab-dpad]="xtabdpad"
  [attr.y-tab-dpad]="ytabdpad"
  [id]="id"
  [ngClass]="{ 'select-disable': disabled }"
  [disabled]="disabled"
  [(ngModel)]="selectedValues"
  (ngModelChange)="onChangeValueTV($event)"
>
  <option
    class="option-item"
    *ngFor="let item of options"
    [value]="item.value"
  >
    {{ item.name || "" }}
  </option>
  <option *ngIf="isReset" disabled hidden selected></option>
</select>
